module.exports = __webpack_public_path__ + "static/img/14000684.f1a1ab81.png";